import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'DossierFinder/BulkDownloadInfo', method: 'POST', body: body, token: token })
}
